module.exports = adInfo => {
  const { label, ad_graphic, end_time, start_time, link } = adInfo;
  const graphic = ad_graphic;

  const ad = document.createElement('div');
  ad.classList.add('ad');
  
  const a = document.createElement('a');
  a.href = link;
  a.id = adInfo.id;
  a.classList.add('ad__link');

  const img = document.createElement('img');
  img.classList.add('ad__graphic');
  img.src = graphic.url;
  img.width = graphic.width;
  img.height = graphic.height;
  img.alt = graphic.alt;

  a.appendChild(img);
  ad.appendChild(a);

  return ad;

}
